import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ФИО"),
    /*#__PURE__*/_createElementVNode("th", null, "Дата рождения"),
    /*#__PURE__*/_createElementVNode("th", null, "Данные документа"),
    /*#__PURE__*/_createElementVNode("th", null, "Адрес регистрации"),
    /*#__PURE__*/_createElementVNode("th", null, "MO"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    class: "text-center font-weight-bold"
  }, "Нет данных")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Вы собираетесь добавить", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "В качестве опекуна для", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Вы собираетесь удалить", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Из опекунов у", -1)

import { CitizensService, Citizen, citizenGetFullname, citizenGetAddress, CitizenFullInfo } from '@prodcard/core'
import { VCitizenFullInfoSelect } from '../../../../components'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import { ref, Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizenGuardiansTab',
  props: {
    citizensService: {},
    citizen: {}
  },
  setup(__props: any) {

const props = __props;



const loading = ref(false)
const guardiansInfo: Ref<CitizenFullInfo[]> = ref([])
const newGuardian: Ref<CitizenFullInfo | undefined> = ref(undefined)
const guardianToDelete: Ref<CitizenFullInfo | undefined> = ref(undefined)
const showDeleteConfirmation = ref(false)
const showAddDialog = ref(false)

handleError(async () => {
  if (props.citizen.guardianIds) {
    guardiansInfo.value = (
      await props.citizensService.findAllWithInfo(createCtx(), { filter: { ids: props.citizen.guardianIds } })
    ).items
  }
}, loading)

const addGuardian = (guardianInfo?: CitizenFullInfo) => {
  showAddDialog.value = false
  if (!guardianInfo) {
    return
  }
  handleError(async () => {
    await props.citizensService.addDependent(createCtx(), props.citizen.id, guardianInfo.citizen.id)
    guardiansInfo.value.push(guardianInfo)
    newGuardian.value = undefined
    callSuccessToast('Данные гражданина обновлены')
  }, loading)
}

const deleteGuardian = (guardianInfo?: CitizenFullInfo) => {
  showDeleteConfirmation.value = false
  if (!guardianInfo) {
    return
  }
  handleError(async () => {
    await props.citizensService.removeDependent(createCtx(), props.citizen.id, guardianInfo.citizen.id)
    const depId = guardiansInfo.value.indexOf(guardianInfo)
    guardiansInfo.value.splice(depId, 1)
    guardianToDelete.value = undefined
    callSuccessToast('Данные гражданина обновлены')
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { hover: "" }, {
              default: _withCtx(() => [
                _hoisted_1,
                (guardiansInfo.value.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guardiansInfo.value, (guardianInfo) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: guardianInfo.citizen.id,
                          to: { path: `/citizens/${guardianInfo.citizen.id}/edit` },
                          custom: ""
                        }, {
                          default: _withCtx(({ navigate }) => [
                            _createElementVNode("tr", {
                              onClick: navigate,
                              style: {"cursor":"pointer"}
                            }, [
                              _createElementVNode("td", null, _toDisplayString(_unref(citizenGetFullname)(guardianInfo.citizen)), 1),
                              _createElementVNode("td", null, _toDisplayString(guardianInfo.citizen.birthdate.toLocaleDateString()), 1),
                              _createElementVNode("td", null, _toDisplayString(guardianInfo.document.info), 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(citizenGetAddress)(guardianInfo.citizen)), 1),
                              _createElementVNode("td", null, _toDisplayString(guardianInfo.municipalEntity), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_btn, _mergeProps({ icon: "mdi-delete" }, props, {
                                  variant: "text",
                                  size: "small",
                                  onClick: _withModifiers(
                  () => {
                    guardianToDelete.value = guardianInfo
                    showDeleteConfirmation.value = true
                  }
                , ["stop"])
                                }), null, 16, ["onClick"])
                              ])
                            ], 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tfoot", _hoisted_4, _hoisted_6))
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "mt-5",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddDialog.value = true)),
              variant: 'tonal'
            }, {
              default: _withCtx(() => [
                _createTextVNode("Добавить опекуна")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 1,
          type: "heading@3, actions"
        })),
    _createVNode(_component_v_dialog, {
      modelValue: showAddDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showAddDialog).value = $event)),
      "max-width": 500
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-5",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "justify-end align-start pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {;(showAddDialog.value = false), (newGuardian.value = undefined)})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!newGuardian.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(VCitizenFullInfoSelect), {
                    modelValue: newGuardian.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newGuardian).value = $event)),
                    "citizens-service": _ctx.citizensService,
                    except: [_ctx.citizen.id, ...guardiansInfo.value?.map(d => d.citizen.id)],
                    label: 'Новый опекун'
                  }, null, 8, ["modelValue", "citizens-service", "except"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      class: "text-primary text-decoration-underline text-body-2",
                      to: { path: '/citizens/new', query: { redirectToBack: 'true' } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Либо вы можете создать нового гражданина-опекуна ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(newGuardian.value.citizen)) + " (" + _toDisplayString(newGuardian.value.citizen.birthdate.toLocaleDateString()) + ")", 1),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)) + " (" + _toDisplayString(_ctx.citizen.birthdate.toLocaleDateString()) + ")", 1),
                  _createVNode(_component_v_card_actions, { class: "justify-end mt-3 pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: 'plain',
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (newGuardian.value = undefined))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Назад")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        variant: 'tonal',
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (addGuardian(newGuardian.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Добавить")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteConfirmation.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDeleteConfirmation).value = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-5",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "justify-end align-start pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showDeleteConfirmation.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (guardianToDelete.value)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(guardianToDelete.value.citizen)) + " (" + _toDisplayString(guardianToDelete.value.citizen.birthdate.toLocaleDateString()) + ")", 1),
                    _hoisted_14,
                    _hoisted_15,
                    _createElementVNode("strong", null, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)) + " (" + _toDisplayString(_ctx.citizen.birthdate.toLocaleDateString()) + ")", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: 'tonal',
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteGuardian(guardianToDelete.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Удалить")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})